import {Component, EventEmitter, inject, Input, OnInit, Output} from "@angular/core";
import {AssetValuation, EMPTY_ASSET_VALUATION} from "../../../models/asset-valuation/asset-valuation";
import {Store} from "@ngrx/store";
import {FormBuilder} from "@angular/forms";
import {selectIsAnyAssetFormInEditMode} from "../../../store/asset/asset.selectors";

@Component({
    selector: "valumize-asset-valuation-rationale",
    templateUrl: "./asset-valuation-rationale.component.html",
    styleUrls: ["./asset-valuation-rationale.component.scss"],
    standalone: false
})
export class AssetValuationRationaleComponent implements OnInit {
    private readonly store = inject(Store);
    private readonly formBuilder = inject(FormBuilder);

    @Input() assetValuation: AssetValuation = EMPTY_ASSET_VALUATION;
    @Input() rationaleIsEditable = false;

    @Output() editRationale = new EventEmitter();
    @Output() cancelRationale = new EventEmitter();
    @Output() saveRationale = new EventEmitter<string>();


    isEditDisabled$ = this.store.select(selectIsAnyAssetFormInEditMode);

    constructor() {
    }

    rationaleForm = this.formBuilder.group({
        rationale: this.formBuilder.control<string | undefined>("", {nonNullable: true})
    });

    ngOnInit() {
        this.rationaleForm.controls.rationale.patchValue(this.assetValuation.rationale.text ?? undefined);
    }

    edit = () => this.editRationale.emit();

    cancel = () => this.cancelRationale.emit();

    save() {
        if (this.rationaleForm.valid) {
            this.saveRationale.emit(this.rationaleForm.getRawValue().rationale);
        }
    }
}
